import Form         from '@widesk-ui/components/form/Form';
import Input        from '@widesk-ui/components/form/Input';
import Box          from '@widesk-ui/components/Box';
import View         from '@widesk-ui/components/View';
import useTheme     from '@widesk-ui/hooks/useTheme';
import Spin         from '@widesk-ui/components/Spin';
import useDidMount  from '@widesk-core/hooks/useDidMount';
import Link         from '@widesk-ui/components/Link';
import Title        from '@widesk-ui/components/Title';
import { useState } from 'react';
import { message }  from '@widesk-ui/hooks/useMessage';
import React        from 'react';

type ResetPasswordPageProps = {
	header?: React.ReactNode;
	onSubmit: (username: string) => Promise<void>;
}

export default function ResetPasswordPage(props: ResetPasswordPageProps) {
	const theme = useTheme();

	const [loading, setLoading] = useState(false);

	useDidMount(() => document.title = 'Mot de passe oublié');

	return (
		<View heightF center gap="lg">
			<Box style={{ width: 460, padding: theme.marginLG }}>
				<View gap="xxl">
					{props.header}

					<Spin size="large" spinning={loading}>
						<Title mb="md" center level={3}>Mot de passe oublié</Title>
						<Form
							fields={{
								username: {
									span: 24,
									element: <Input id="username" placeholder="Adresse email" size="large" />,
									required: true,
								},
							}}
							loading={loading}
							onSubmit={async ({ username }) => {
								try {
									setLoading(true);
									await props.onSubmit(username as string);
									message.success('Un email d\'instructions a été envoyé.');
								} finally {
									setLoading(false);
								}
							}}
							withButton
						/>
					</Spin>

					<View align="center"><Link to="/">Retour à la connexion</Link></View>
				</View>
			</Box>
		</View>
	);
}
